module.exports = __webpack_public_path__ + "img/sgkt.dfc0bd00.jpg";